import './component.scss'
import '@splidejs/splide/css';
import { Splide } from '@splidejs/splide';
import '../../nurikae/top_reform_example_card/component';

const PC_PER_PAGE = 3;

const SLIDER_CONFIGS = {
  'top-reform-pc': {
    speed: 800,
    perPage: PC_PER_PAGE,
    perMove: PC_PER_PAGE,
    gap: '8px',
    pagination: false,
  },
  'top-reform-sp': {
    speed: 800,
    perMove: 1,
    gap: '12px',
    padding: '30px',
    pagination: false,
    focus: 'center',
  }
};

// スライダー初期化関数
function initializeSlider (id, config) {
  const element = document.getElementById(id);
  if (!element) return null;

  const splide = new Splide(`#${id}`, config);
  splide.mount();
}

window.addEventListener('load', function () {
  Object.entries(SLIDER_CONFIGS).forEach(([id, config]) => { initializeSlider(id, config); });
});
